import '../styles/publications.css';

import { store } from '../state';
import { i18n } from '../i18n';
import type {AppState} from '../types';
import { publicationsAPI } from '../api';
import { renderTemplate } from '../template-engine';
import publicationCardTpl from '../templates/publication-card.html?raw';

// Элементы DOM, нужные только для публикаций
const els = {
  publicationsListContainer: document.getElementById('publications-list-container') as HTMLElement,
};

// Загрузка публикаций
export async function loadPublications(): Promise<void> {
  const state = store.getState();
  if (state.publicationsList.length > 0 || state.publicationsLoading) return;

  store.dispatch({ type: 'SET_PUBLICATIONS_LOADING', payload: true });
  
  try {
    const response = await publicationsAPI.list();
    store.dispatch({ type: 'SET_PUBLICATIONS_LIST', payload: response.publications });
    console.log('✅ Публикации загружены:', response.publications.length);
  } catch (error) {
    console.error('❌ Ошибка загрузки публикаций:', error);
    store.dispatch({ 
      type: 'SET_PUBLICATIONS_ERROR', 
      payload: i18n.t('publications.error.load') 
    });
  }
}

// Рендеринг списка публикаций
export function renderPublications(state: AppState): void {
  if (state.publicationsLoading) {
    els.publicationsListContainer.innerHTML = `
      <div class="state-view loading" style="min-height: 150px;">
        <div class="spinner" style="width: 30px; height: 30px;"></div>
      </div>`;
  } else if (state.publicationsError) {
    els.publicationsListContainer.innerHTML = `
      <div class="state-view error">
        <p>${state.publicationsError}</p>
      </div>`;
  } else if (state.publicationsList.length === 0) {
    els.publicationsListContainer.innerHTML = `
      <div class="state-view empty">
        <p>${i18n.t('publications.empty')}</p>
      </div>`;
  } else {
    const publicationsData = {
      publications: state.publicationsList.map(p => ({
        title: escapeHtml(p.title),
        authors: escapeHtml(p.authors),
        journal: escapeHtml(p.journal),
        year: p.year,
        abstract: p.abstract ? escapeHtml(p.abstract) : null,
        file: p.file
      }))
    };

    els.publicationsListContainer.innerHTML = renderTemplate(publicationCardTpl, publicationsData);
  }
}

// Вспомогательная функция экранирования
function escapeHtml(str: string): string {
  if (str === null || str === undefined) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}